import axios from "axios";
import { MutantApiService } from "../services/MutantApiService";

export const REGISTER_URL = "api/dashboard";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
const api = new MutantApiService();

export async function login(email, password) {
	return api.makeHttpRequest({
		url: 'auth/login',
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		data: {
			email,
			password
		}
	});
}

export function requestPassword(email) {
	return axios.post(REQUEST_PASSWORD_URL, { email });
}
